import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'
import dotProp from 'dot-prop-immutable'

const normalizePupils = data => {
  const pupil = new schema.Entity(
    'pupils',
    {},
    { idAttribute: pupil => pupil.account.id }
  )
  return normalize(data, [pupil])
}

let defaultState = null

const PupilsReducer = combineReducers({
  fetching: createRequestReducer('PUPILS_STORE:FETCHING', { pending: true }),
  updating: createMappedRequestReducer('PUPILS_STORE:UPDATE_PUPIL'),
  deleting: createMappedRequestReducer('PUPILS_STORE:RETIRE_PUPIL'),
  creating: createMappedRequestReducer('PUPILS_STORE:CREATE_PUPIL'),
  creatingBatch: createRequestReducer('PUPILS_STORE:CREATE_PUPIL_BATCH'),
  addingToGroup: createMappedRequestReducer('PUPILS_STORE:ADD_PUPIL_TO_GROUP'),
  incrementingAge: createMappedRequestReducer(
    'PUPILS_STORE:INCREMENT_AGE_GROUP'
  ),
  removingFromGroup: createMappedRequestReducer(
    'PUPILS_STORE:REMOVE_PUPIL_FROM_GROUP'
  ),
  pupils: createReducer(defaultState, {
    'PUPILS_STORE:SET_PUPILS': (state, { pupils }) => normalizePupils(pupils),
    'PUPILS_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      normalizePupils(response.data.school.student_types),
    'PUPILS_STORE:UPDATE_PUPIL_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      entities: {
        pupils: {
          ...state.entities.pupils,
          [response.data.account.id]: {
            ...state.entities.pupils[response.data.account.id],
            ...response.data.account.student_type
          }
        }
      }
    }),
    'PUPILS_STORE:RETIRE_PUPIL_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      result: state.result.filter(id => id !== params.id)
    }),
    'PUPILS_STORE:ADD_PERMISSION_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      entities: {
        pupils: {
          ...state.entities.pupils,
          [params.id]: {
            ...state.entities.pupils[params.id],
            policy: {
              ...state.entities.pupils[params.id].policy,
              can_publish: true
            }
          }
        }
      }
    }),
    'PUPILS_STORE:REMOVE_PERMISSION_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      entities: {
        pupils: {
          ...state.entities.pupils,
          [params.id]: {
            ...state.entities.pupils[params.id],
            policy: {
              ...state.entities.pupils[params.id].policy,
              can_publish: false
            }
          }
        }
      }
    }),
    'PUPILS_STORE:ADD_PUPIL_TO_GROUP_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => ({
      ...state,
      entities: {
        pupils: {
          ...state.entities.pupils,
          [params.id]: {
            ...state.entities.pupils[params.id],
            groups: [
              ...state.entities.pupils[params.id].groups,
              params.groups[response.data.group.id]
            ]
          }
        }
      }
    }),
    'PUPILS_STORE:REMOVE_PUPIL_FROM_GROUP_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => ({
      ...state,
      entities: {
        pupils: {
          ...state.entities.pupils,
          [params.id]: {
            ...state.entities.pupils[params.id],
            groups: state.entities.pupils[params.id].groups.filter(
              group => group.id !== params.groupId
            )
          }
        }
      }
    }),
    'PUPILS_STORE:INCREMENT_AGE_GROUP_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) =>
      dotProp.set(
        state,
        `entities.pupils.${params.id}.year_group`,
        () => response.data.account.student_type.year_group
      )
  })
})

export default PupilsReducer
